<template>
    <div>
        <div class="breadcrumb-box">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item back">
                        <a
                            href="#"
                            @click="$router.go(-1)"
                            style="font-family: proxima-nova, sans-serif"
                            >Back</a
                        >
                    </li>
                    <li
                        class="breadcrumb-item"
                        style="font-family: proxima-nova, sans-serif"
                    >
                        Restore User List
                    </li>
                </ol>
            </nav>
        </div>

        <div class="form-box mt-5">
            <div class="d-flex justify-content-between align-items-center">
                <h2
                    class="form-box__title"
                    style="font-family: proxima-nova, sans-serif"
                >
                    Restore User List
                </h2>
            </div>

            <table class="table tms-table">
                <thead>
                    <tr>
                        <th>No.</th>
                        <th>User/Ekspedisi</th>
                        <th>Role</th>
                        <th>Date Created</th>
                        <th>Status</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(user, index) in plants" :key="user.id">
                        <td>{{ index + 1 }}</td>
                        <td>{{ user.username }}</td>
                        <td>{{ user.type }}</td>
                        <td>{{ user.created_at }}</td>
                        <td>{{ user.status }}</td>
                        <td>
                            <button
                                class="tms-button-circular"
                                @click="restorePlant(user.id)"
                            >
                                <i class="fas fa-undo-alt"></i>
                            </button>
                            <!-- Button to trigger restore action -->
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
    metaInfo: {
        title: "Restore User List",
    },
    data() {
        return {
            plants: [],
        };
    },
    components: {},
    created() {
        this.fetchPlants();
    },
    watch: {},
    methods: {
        fetchPlants() {
            axios
                .get("/api/user/restore")
                .then((response) => {
                    this.plants = response.data.data.map((user) => ({
                        ...user,
                        status: this.getStatusText(user.status),
                        created_at: this.formatDate(user.created_at),
                    }));
                })
                .catch((error) => {
                    console.error("Error fetching plants:", error);
                });
        },
        getStatusText(status) {
            return status === 1 ? "Active" : "Inactive";
        },
        formatDate(isoDateString) {
            const date = new Date(isoDateString);
            const day = date.getDate().toString().padStart(2, "0");
            const month = (date.getMonth() + 1).toString().padStart(2, "0");
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        },
        restorePlant(id) {
            Swal.fire({
                title: "Confirm Restore",
                text: "Are you sure you want to restore this User?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes",
                cancelButtonText: "Cancel",
            }).then((result) => {
                if (result.isConfirmed) {
                    axios
                        .put(`/api/user/restore/${id}`)
                        .then((response) => {
                            console.log(
                                "user restored successfully:",
                                response.data
                            );
                            Swal.fire(
                                "Success!",
                                "user restored successfully!",
                                "success"
                            );
                            this.fetchPlants(); // Fetch updated user list after restoration
                        })
                        .catch((error) => {
                            console.error("Error restoring user:", error);
                            Swal.fire(
                                "Error!",
                                "Failed to restore user",
                                "error"
                            );
                        });
                }
            });
        },
    },
};
</script>

<style scoped>
.tms-button-circular {
    width: 40px; /* Set the width and height to the same value for a perfect circle */
    height: 40px;
    border-radius: 50%; /* Makes the button circular */
    background-color: #d8e4ff; /* Sets the background color */
    padding: 10px 20px; /* Adjust padding to fit your content */
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border: none;
    outline: none;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); /* Adjust shadow values as needed */
}

/* tms-table start */
.tms-table {
    width: 100%;
    border-collapse: collapse;
    font-family: proxima-nova, sans-serif;
}

.tms-table th,
.tms-table td {
    padding: 8px;
    text-align: left;
    vertical-align: middle;
    font-family: proxima-nova, sans-serif;
}

/* Styling for table headers */
.tms-table th {
    color: #bcbcbc;
    font-weight: normal;
    border-bottom: 0px solid #e4e7ea;
    font-family: proxima-nova, sans-serif;
}

/* Styling for table data cells */
.tms-table td {
    font-weight: normal;
    font-family: proxima-nova, sans-serif;
}

/* Remove top border from first row */
.tms-table tr:first-child td {
    border-top: none;
    font-family: proxima-nova, sans-serif;
}
/* tms-table end */
</style>
